module.exports = __webpack_public_path__ + "media/team_admin/delete-aad9efa3.png";